import React from "react";
import "./Nav.css"

const Nav = ()=>{
    
        return(
            <div className="nav">
                MY TODOS
            </div>
        );

}

export default Nav;


